<template>
  <div style="margin-top:0px;margin-left: 0px;margin-right: 0px">
    <el-row style="margin-top: 10px" type="flex" class="row-bg" justify="center">
      <el-col :span="4" >
        <h6 style="margin-top: 20px;margin-bottom: 10px;margin-left: 10px">Classified by</h6>
        <el-menu
            default-active="1-2-1"
            class="el-menu-vertical-demo"
        >


          <el-submenu index="1">
            <template slot="title">
              <i style="color: #409EFF" class="el-icon-menu"></i>
              <span>In Vivo/Vitro</span>
            </template>
            <el-menu-item index="1-1" @click="getvivo">In Vivo</el-menu-item>

            <el-submenu index="1-2">
              <template slot="title">In Vitro </template>
              <el-menu-item index="1-2-1" @click="getRNAs">RNA(s)

              </el-menu-item>
              <el-menu-item index="1-2-2" @click="getRNA_Proteins">RNA+protein(s)

              </el-menu-item>
              <el-menu-item index="1-2-3" @click="getRNAs_Proteins">RNAs+protein(s)


              </el-menu-item>
            </el-submenu>

          </el-submenu>


          <el-submenu index="2">
            <template slot="title">
              <i style="color: #ffd04b" class="el-icon-menu"></i>
              <span>RNA type</span>
            </template>
            <el-submenu index="2-1">
              <template slot="title">Natural RNA </template>
              <el-menu-item index="2-1-1" @click="getmrna">mRNA</el-menu-item>
              <el-menu-item index="2-1-2" @click="getlncrna">lncRNA</el-menu-item>
              <el-menu-item index="2-1-3" @click="getmirna">miRNA</el-menu-item>
              <el-menu-item index="2-1-4" @click="getrrna">rRNA</el-menu-item>
              <el-menu-item index="2-1-5" @click="getsirna">siRNA</el-menu-item>
              <el-menu-item index="2-1-6" @click="getsnrna">snRNA</el-menu-item>
              <el-menu-item index="2-1-7" @click="getsnorna">snoRNA</el-menu-item>
              <el-menu-item index="2-1-8" @click="getpirna">piRNA</el-menu-item>
              <el-menu-item index="2-1-9" @click="gettotalrna">total RNA</el-menu-item>
              <el-menu-item index="2-1-10" @click="getvirysrna">virus RNA</el-menu-item>
            </el-submenu>
            <el-submenu index="2-2">
              <template slot="title">Designed RNA </template>
              <el-menu-item index="2-2-1" @click="getpoly">poly RNA</el-menu-item>
              <el-menu-item index="2-2-2" @click="getfr">repeat RNA</el-menu-item>
              <el-menu-item index="2-2-4" @click="getnr">nucleotide rich RNA</el-menu-item>
              <el-menu-item index="2-2-3" @click="getir">irregular RNA</el-menu-item>
            </el-submenu>
          </el-submenu>

        </el-menu>
        <el-divider></el-divider>
        <p style="font-size: 1rem;font-weight: bold ;margin-top: 0px;margin-left: 10px">Note:</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>RNA: single RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>RNAs: multiple RNAs</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>RNA(s): one or more RNAs</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>protein(s): one or more proteins</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>miRNA: microRNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>rRNA: ribosomal RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>siRNA: small interfering RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>snRNA: small nuclear RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>snoRNA: small nucleolar RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>piRNA: Piwi-interactiing RNA</p>
        <p style="font-size: 0.8rem;color: #606266;margin-left: 10px"> <a style="font-weight: bold">·</a>total RNA: all RNA extracted from the cell</p>
      </el-col>

      <el-col :span="19" style="padding-left: 1%">
        <!--        :data="tableData.slice((currpage - 1) * pagesize, currpage * pagesize)"-->
        <div style="padding: 2px;border: 2px solid #eef1f6">

          <el-table
              v-if="tableData"

              :data="tableData.slice((currpage - 1) * pagesize, currpage * pagesize)"
              @sort-change="sort_change"
              style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'0.8rem'}"
              :cell-style="{fontSize: '0.8rem'}"
              stripe

              highlight-current-row
              border
              :row-style="{height:'64px'}"
          >
            <el-table-column
                prop="Psid"
                label="RNAPSID"
                align= "center"
                sortable
            >
              <template slot-scope="scope">
                <router-link  target="_blank" v-bind:to="/Detail/+scope.row.Psid">{{scope.row.Psid}}</router-link>
              </template>

            </el-table-column>

            <el-table-column
                prop="Nucleic_acid"
                label="RNA"
                align= "center"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="RNA_len"
                label="RNA length"
                align= "center"
                sortable
            >
              <template slot-scope="scope">
                <a style="color: #606266">{{scope.row.RNA_length}}</a>
              </template>
            </el-table-column>
            <el-table-column
                prop="Rna_classification"
                label="RNA type"
                align= "center"
                sortable
            >

            </el-table-column>
            <el-table-column
                prop="Rna_source"
                label="RNA species"
                align= "center"
                sortable
            >
            </el-table-column>

            <el-table-column
                prop="Protein_name"
                label="Protein name"
                align= "center"
                sortable
                v-if="show"
            >

            </el-table-column>
            <el-table-column
                prop="Components_type"
                label="Component type"
                align= "center"
                sortable
                v-if="show1"
            >

            </el-table-column>
            <el-table-column
                prop="Vivo_or_vitro"
                label="Vivo/Vitro"
                align= "center"
                sortable
                width="110"
            >
            </el-table-column>


          </el-table>
          <div style="padding: 2px"></div>
          <el-pagination background
                         layout="prev, pager, next, sizes, total, jumper"
                         :page-sizes="[5, 10, 15, 20]"
                         small
                         :page-size="pagesize"
                         :current-page="currpage"
                         :total="tableData.length"
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getRNA_Proteins,getRNAs_Proteins,getpirna,getsnorna,getRNAs,getvivo,getvitro,getpoly,getnr,getir,getlncrna,getmrna,getfr,getrrna,getsirna,gettotalrna,getvirysrna,getmirna,getsnrna} from "@/network/DataClassification";

export default {
  name: "RNA_Proteins",
  data() {
    return {
      tableData: [],
      // tableData1: [],
      pagesize:10,
      currpage:1,
      proptype: "",
      show:true,
      show1:true,
      indexselect:'',

    }
  },

  created() {
    this.getRNAs()
  },
  methods:{
    getRNA_Proteins(){
      this.currpage=1
      getRNA_Proteins().then(res => {
        let a=res.list
        let arr=[]

        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.RNA_len=a[i].fields.rnalenub
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr
        this.show=true
        this.show1=true

      })
    },
    getRNAs_Proteins(){
      this.currpage=1
      getRNAs_Proteins().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.show=true
        this.show1=true
        this.tableData=arr

      })
    },
    getRNAs(){
      this.currpage=1
      getRNAs().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.RNA_len=a[i].fields.rnalenub
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=false
        this.show1=true
      })
    },
    getvivo(){
      this.currpage=1
      getvivo().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          // obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=false
      })
    },
    getvitro(){
      this.currpage=1
      getvitro().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getmrna(){
      this.currpage=1
      getmrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getsnrna(){
      this.currpage=1
      getsnrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getmirna(){
      this.currpage=1
      getmirna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getlncrna(){
      this.currpage=1
      getlncrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },

    getsnorna(){
      this.currpage=1
      getsnorna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },

    getpirna(){
      this.currpage=1
      getpirna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },

    getrrna(){
      this.currpage=1
      getrrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },

    getsirna(){
      this.currpage=1
      getsirna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    gettotalrna(){
      this.currpage=1
      gettotalrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getvirysrna(){
      this.currpage=1
      getvirysrna().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getpoly(){
      this.currpage=1
      getpoly().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getfr(){
      this.currpage=1
      getfr().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getir(){
      this.currpage=1
      getir().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },
    getnr(){
      this.currpage=1
      getnr().then(res => {
        let a=res.list
        let arr=[]
        for (let i=0;i<a.length;i++){
          let obj={}
          obj.Psid=a[i].fields.rpsid
          obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
          obj.Components_type=a[i].fields.components_type
          obj.RNA_len=a[i].fields.rnalenub
          obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
          obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
          obj.Rna_source=a[i].fields.source.split('|').join('\n')
          obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
          obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
          arr.push(obj)
        }for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].Psid == arr[j].Psid) {
              arr.splice(j, 1);
              //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
              j--;
            }
          }
        }
        this.tableData=arr

        this.show=true
        this.show1=true
      })
    },

    sort_change(column) {


      this.currpage = 1; // 排序后返回第一页

      // 将键名prop赋值给变量proptype

      // if(column.prop==='RNA_length'){
      //   this.proptype='Psid'
      // }else {
        this.proptype = column.prop;
      // }

      if (column.order === "descending") {
        this.tableData.sort(this.my_desc_sort);
      } else if (column.order === "ascending") {
        this.tableData.sort(this.my_asc_sort);

      }




    },
    //排序方法
    my_desc_sort(a, b) {

      if (a[this.proptype] > b[this.proptype]) {
        return -1
      } else if (a[this.proptype] < b[this.proptype]) {
        return 1
      } else {
        return 0
      } // a["time"] 等价于 a.time
    },
    my_asc_sort(a, b) {
      if (a[this.proptype] > b[this.proptype]) {
        return 1
      } else if (a[this.proptype] < b[this.proptype]) {
        return -1
      } else {
        return 0
      }
    }
    ,
    handleCurrentChange(cpage) {
      this.currpage = cpage;
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
    }
  },
  // watch:{
  //   tableData() {
  //     this.tableData1 = this.dataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
  //   }
  // }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #0e63bb;
}
.el-divider--horizontal{
  margin-top: 5px !important;
  margin-bottom: 15px !important;
}

span{
  font-size: 0.9rem;
}

</style>
<style>


.el-submenu .el-menu-item{
  min-width: 20px !important;
}
.el-menu {
  border-right:0!important;
}

</style>